import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';

const Footer = () => {
  return (
    <AppBar
      position="static"
      style={{ backgroundColor: '#7A3E3E' }}
      sx={{
        top: 'auto',
        bottom: 0,
      }}
    >
      <Toolbar>
        <Box flexGrow={1}>
          <Typography variant="body2" align="center">
            © 2023 - 2024 Cognitive Computing Lab, Gachon University.
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Footer;
